import { BehaviorSubject, Subject } from 'rxjs';
import { Component,OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UserAppsService, UsersService } from 'app/services';

import { ConfirmDeleteDialogComponent } from '../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { User } from 'app/models';
import { UserDialogComponent } from './user-dialog/user-dialog.component';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { RecoverUserDialogComponent } from './user-recovery-dialog/user-recovery-dialog.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { SelectionModel } from '@angular/cdk/collections';
import * as tableHelpers from 'app/helpers/tableSelectionHelpers';
import { MatSort } from '@angular/material/sort';
import { environment } from 'environments/environment';

@Component({
  standalone: false,
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit, OnDestroy {
  displayedColumns = [
    'select',
    'name',
    'email',
    'lastLogin',
    'emailVerified'
  ]
  message = 'Users_not_found';
  title = '';
  error: string;
  noRecordFound: boolean;
  queryString: string;
  loading: boolean;
  public selectedUsers: User[];
  private searchValSubject = new BehaviorSubject<string>(null);
  searchVal$ = this.searchValSubject.asObservable();
  currentPageUsers: User[];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  usersDataSource =  new MatTableDataSource([]);
  selection = new SelectionModel<User>(true, []);
  constructor(
    public _userServ: UsersService,
    private _dialog: MatDialog,
    private _userAppsService: UserAppsService,
    private _translateService: TranslateService
  ) {}
  private onDestroy$ = new Subject<void>();

  ngOnInit() {
    this.getHeader(false);
    this._userServ.users$.pipe(takeUntil(this.onDestroy$)).subscribe(users => {
      if (users && users.length) {
        users.map(user => {
          user.lastLogin = new Date(user.lastLogin).toLocaleString();
        });
        this._userServ.userList = users;
        this.noRecordFound = false;
        this.selection.clear();
        this.loading = false;
        this.usersDataSource.data = this._userServ.userList;
        setTimeout(() => {
          this.usersDataSource.paginator = this.paginator;
          this.usersDataSource.sort = this.sort;
          this.usersDataSource.sortingDataAccessor = tableHelpers.sortingDataAccessor;
        }, 10);
        this.usersDataSource
            .connect()
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((usersList) => {
              this.currentPageUsers = usersList;
            });
      } else {
        this._userServ.userList = [];
        this.noRecordFound = true;
      }
    });
    this._userServ.error$.pipe(takeUntil(this.onDestroy$)).subscribe(error => {
      this.error = error;
    });
    this.searchVal$
      .pipe(takeUntil(this.onDestroy$), debounceTime(600))
      .subscribe(res => {
        if (res !== '' && res != null) {
          this.getHeader(true);
          const encodedSearch = encodeURIComponent(this.queryString);
          this._userServ.searchUsers(encodedSearch);
        }
      });

    this.loading = true;
    this._userServ.getTopTenUsers();
  }

  isAllSelected = () => tableHelpers.isAllSelected(this.currentPageUsers, this.selection.selected);

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle = () => tableHelpers.masterToggle(this.currentPageUsers, this.selection);

  isPartiallySelected = () => tableHelpers.isPartiallySelected(this.currentPageUsers, this.selection.selected);


  getHeader(isSearch: boolean) {
    let url = 'Last_Registered_Users';
    if (isSearch) {
      url = 'Search_Results';
    }
    this._translateService
      .get(url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(value => {
        this.title = value;
      });
  }
  recoverUserDialog() {
    const dialog = this._dialog.open(RecoverUserDialogComponent, {
      disableClose: true,
      autoFocus: false,
      width: '600px',
    });
    dialog.afterClosed().subscribe((result) => {
      if (result) {
        this.loading = true;
      }
    });
  }
  userDelete() {
    if (this.selection.selected.length > 0) {
      let deleteConfirmation = '';
      this._translateService
      .get('USERS.delete_confirmation')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(value => {
        deleteConfirmation = value;
      });
      const dialog = this._dialog.open(ConfirmDeleteDialogComponent, {
        disableClose: true,
        autoFocus: false,
        data: {
          users: this.selection.selected,
          title: deleteConfirmation,
          isWarning: true
        }
      });
      dialog.afterClosed().subscribe(result => {
        if (result) {
          this._userServ.deleteUsers(this.selection.selected);
          this.selection.clear();
        }
      });
    }
  }

  selectedRecords(event) {
    this.selectedUsers = event;
  }

  monitorSearch(search: string) {
    this.queryString = search.trim();
    this.error = '';
    if (this.queryString == null || this.queryString === '') {
      this._userServ.getTopTenUsers();
      this.getHeader(false);
    } else if (this.queryString.length >= Number(environment.minimumSearchLength)) {
      this.searchValSubject.next(search);
    }
  }

  openUserProfile(selectedUser) {
    const dialog = this._dialog.open(UserDialogComponent, {
      disableClose: true,
      panelClass: 'no-padding-dialog',
      autoFocus: false,
      width: '880px',
      data: {
        user: selectedUser
      }
    });
    dialog.afterClosed().subscribe(result => {
    });
  }

  handleRowClick(event) {
    this._userAppsService.clearSubscription();
    this.openUserProfile(event);
  }

  handleColumnClick(event) {}

  handleCellClick(event) {}

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
